import { ApiUrls } from '../endpoints';
import api from '../createApiClient';

export const azureADB2CAuthentication = async (email, password) => {
  try {
    const dataUrl = `${ApiUrls.base}/login`;
    const data = {
      userEmail: email,
      password: password
    }
    const response = await api.post(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error Authentication AzureADB2C  :', error);
    throw error;
  }
};

export const validateJwtToken = async (token) => {
  try {
    const dataUrl = `${ApiUrls.base}/validate-issuer-token`;
    const response = await api.post(dataUrl, { token: token });
    return response.data;
  } catch (error) {
    console.error('Error validating token:', error);
    throw error;
  }
};

export const validateCompanyJwtToken = async (token) => {
  try {
    const dataUrl = `${ApiUrls.base}/validate-company-issuer-token`;
    const response = await api.post(dataUrl, { token: token });
    return response.data;
  } catch (error) {
    console.error('Error validating token:', error);
    throw error;
  }
};

export const validateEmail = async (email) => {
  try {
    const dataUrl = `${ApiUrls.base}/validate-emailaddress`;
    const response = await api.post(dataUrl, { email: email });
    return response.data.success;
  } catch (error) {
    console.error('Error validating email:', error);
    throw error;
  }
};

export const validateSignupJwtToken = async (token) => {
  try {
    const dataUrl = `${ApiUrls.base}/validate-signup-token`;
    const response = await api.post(dataUrl, { token: token });
    return response.data;
  } catch (error) {
    console.error('Error validating token:', error);
    throw error;
  }
};

export const appLogout = async () => {
  try {
    const dataUrl = `${ApiUrls.base}/logout`;
    const response = await api.post(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error logout:', error);
    throw error;
  }
};
